<template>
  <div class="page-container content-430">
    <div class="head-card">基本信息</div>
    <BaseInfo ref="baseInfoRef" :details="details"></BaseInfo>
    <div class="head-card">优惠内容</div>
    <Content ref="contentRef" :details="details"></Content>
    <div class="head-card">领取/派送限制</div>
    <Limitation ref="limitationRef" :details="details"></Limitation>
    <div class="footer-main">
      <div class="flex justify-content" style="margin-left: -22%">
        <Button style="margin-right: 50px" @click="handleCancel('formValidate')"
          >取消</Button
        >
        <Button type="primary" @click="handleCfm('formValidate')">保存</Button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInfo from './components/BaseInfo.vue'
import Limitation from './components/Limitation.vue'
import Content from './components/Content.vue'
import orderCenterApi from '@/request/orderCenter/index.js';
import { mapMutations } from "vuex";
export default {
  components: {
    BaseInfo,
    Content,
    Limitation
  },
  data() {
    return {
      couponId: this.$route.query.couponId,
      details: null
    }
  },
  created() {
    if (this.couponId) {
      this.getCouponsDetails()
    }
  },
  methods: {
    ...mapMutations([
      'CLOSE_BROWSINGHISTORYLIST', 'DELETE_CACHEROUTE'
    ]),
    async getCouponsDetails() {
      let res = await orderCenterApi.getCouponsDetails({
        couponId: this.couponId
      })
      if (res.status == 200) {
        this.details = res.message
      }
    },
    handleCancel() {
      this.handleGoBack()
    },
    async handleCfm() {
      if (!await this.$refs.baseInfoRef.checkForm()) {
        return null
      }
      if (!await this.$refs.contentRef.checkForm()) {
        return null
      }
      if (!await this.$refs.limitationRef.checkForm()) {
        return null
      }
      this.handleSubmit()
    },
    async handleSubmit() {
      let baseInfo = await this.$refs.baseInfoRef.getParameter()
      let content = await this.$refs.contentRef.getParameter()
      let limitation = await this.$refs.limitationRef.getParameter()
      let parameter = {
        ...baseInfo,
        ...content,
        ...limitation
      }

      let res
      this.$Spin.show();
      if (this.details) {
        parameter.couponId = this.couponId
        delete parameter.discountType
        delete parameter.schoolName
        delete parameter.schoolId
        delete parameter.termCode
        delete parameter.yearCode
        delete parameter.platType
        res = await orderCenterApi.editCoupons(parameter)
      } else {
        res = await orderCenterApi.addCoupons(parameter)
      }
      this.$Spin.hide();
      if (res.status == 200) {
        this.$Message.success(this.details ? '编辑成功' : '新增成功');
        this.handleGoBack()
      }
    },
    handleGoBack() {
      this.CLOSE_BROWSINGHISTORYLIST(this.$route.name)
      if (!this.details) {
        this.DELETE_CACHEROUTE('courseCenterCouponIndex')
      }
      this.$router.push({
        name: `courseCenter_coupon_index`
      });
    },
    getBaseInfoForm() {
      return this.$refs.baseInfoRef
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding-bottom: 100px !important;
  .head-card {
    background: rgb(247, 248, 250);
    height: 40px;
    padding-left: 20px;
    line-height: 40px;
    font-weight: 600;
    border-radius: 8px;
    margin-bottom: 20px;
  }
  /deep/ .ivu-form-item {
    margin-bottom: 22px !important;
  }
  .footer-main {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: #fff;
    z-index: 99;
    padding: 20px 0;
    left: 180px;
    border-top: 1px solid #eee;
  }
}
</style>